<template>
  <div>
    <div>
      <div class="d-flex justify-center">
        <v-card class="w-100" flat>
          <div v-show="stepOne">
            <div class="d-flex justify-space-between align-center">
              <div class="h1">ADD PAYMENT</div>
              <v-icon @click="close">mdi-close</v-icon>
            </div>
            <div>
              <b> Looking to upgrade? </b>
              <div></div>
              Upgrade options may not be available depending on the User's
              status.
            </div>
            <div>
              <b
                >Status for {{ GetPreviewUser.FirstName }}
                {{ GetPreviewUser.LastName }}
              </b>
            </div>
            <div>Credentials: {{ combinedCredentials }}</div>
            <div>Renewal Date: {{ formatDate(GetPreviewUser?.MembershipDetail[0]?.EndDateTime) }}</div>
            
            <v-card flat outlined class="px-4 mt-4 pt-6">
              <!-- <v-row class="mt-4"> -->
                <!-- <v-col cols="12" md="4"> -->
                  <div class="mb-3">
                    <b class="font-18">Payment For: *</b>
                  </div>
                  <!-- </v-col> -->
                <!-- <v-col cols="12" md="6"> -->
                  <v-select
                    v-model="form.MembershipId"
                    outlined
                    dense
                    single-line
                    label="Select MemberShip Plan"
                    attach
                    item-text="text"
                    item-value="id"
                    :items="membershipData"
                    :error-messages="
                      $v.form.MembershipId.$error
                        ? 'Membership plan is required'
                        : null
                    "
                  >
                  </v-select>
                  <!-- <v-radio-group
                  v-model="PaymentFor"
                  class="pa-0 ma-0"
                  hide-details
                >
                  <v-radio value="RenewMembership">
                    <template v-slot:label>
                      <div class="mt-1">Renew Membership</div>
                    </template>
                  </v-radio>
                  <v-radio value="CBPExam" class="">
                    <template v-slot:label>
                      <div class="mt-1">CBP Exam</div>
                    </template>
                  </v-radio>
                  <v-radio value="CBPAExam" class="">
                    <template v-slot:label>
                      <div class="mt-1">CBP-A Exam</div>
                    </template>
                  </v-radio>
                </v-radio-group> -->
                <!-- </v-col> -->
              <!-- </v-row> -->
              <!-- <v-row> -->
                <!-- <v-col cols="12" md="4"> -->
                  <div class="mb-3">
                    <b class="font-18">Payment Option:</b>
                  </div>
                <!-- </v-col> -->
                <!-- <v-col cols="12" md="6"> -->
                  <v-radio-group v-model="PaymentOption" class="pa-0 ma-0">
                    <v-radio value="online">
                      <template v-slot:label>
                        <div class="mt-1">ONLINE (Process Credit Card)</div>
                      </template>
                    </v-radio>
                    <v-radio value="offline" class="">
                      <template v-slot:label>
                        <div class="mt-1">
                          OFFLINE (Generate record/invoice/email without payment)
                        </div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                <!-- </v-col> -->
              <!-- </v-row> -->
            </v-card>
            <!--------------------------------Data--Table --------------------------------->
            <!-- <table class="w-100">
            <tr>
              <th>
                <div class="d-flex justify-center py-2">Payment Type</div>
              </th>
              <th><div class="d-flex justify-center py-2">Price</div></th>
              <th><div class="d-flex justify-center py-2">Through</div></th>
            </tr>
            <tr>
              <td>
                <div class="d-flex justify-center py-2">Renew Membership</div>
              </td>
              <td><div class="d-flex justify-center py-2">$ 300.00</div></td>
              <td>
                <div class="d-flex justify-center py-2">05 June, 2023</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="d-flex justify-center py-2">Upgrade Membership</div>
              </td>
              <td><div class="d-flex justify-center py-2">$ 0.00</div></td>
              <td>
                <div class="d-flex justify-center py-2">05 June, 2023</div>
              </td>
            </tr>
          </table> -->
          </div>
          <div v-show="stepTwo">
            <div class="d-flex justify-space-between align-center">
              <div class="h1">Online Payment</div>
              <v-icon @click="close">mdi-close</v-icon>
            </div>

            <div class="font-18 my-3"><b>Payment Information</b></div>
            <!-- <v-row> -->
              <!-- <v-col cols="12" md="7"> -->
                <div class="d-flex">
                  <div class="mr-3">User:</div>
                  <div>
                    <b
                      >{{ GetPreviewUser.FirstName }}
                      {{ GetPreviewUser.LastName }}</b
                    >
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-3">Current Membership:</div>
                  <div>
                    <b>{{ getMembershipByUserId?.Name }} </b>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-3">Membership Plan:</div>
                  <div>
                    <b>{{ memberShipName }}</b>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-3">Active through:</div>
                  <div>
                    <b> {{ formatDate(GetPreviewUser?.MembershipDetail[0]?.EndDateTime) }}
                      <!-- {{ getCurrentDateFormatted }} -->
                    </b>
                  </div>
                </div>
                <div class="d-flex">
                  <div class="mr-3">Fee:</div>
                  <div>
                    <b>USD {{ membershipPrice }}</b>
                  </div>
                </div>
              <!-- </v-col> -->
              <!-- <v-col cols="12" md="7">
              <div class="d-flex">
                <div class="mr-3">Description:</div>
                <div>
                  <b>Renew membership from 04 June,2022 to 04 04 June, 2023</b>
                </div>
              </div>
            </v-col> -->
            <!-- </v-row> -->
            <!-- <v-row>
            <v-col cols="2"
              ><div class="d-flex">
                <b class="font-18">Fee:</b>
              </div></v-col
            >
            <v-col cols="10">
              <v-radio-group v-model="PaymentInformationFee" class="pa-0 ma-0">
                <v-radio value="standardmembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">Standard Membership</div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 150.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
                <v-radio value="practicingmembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">
                          Practicing Membership
                        </div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 300.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
                <v-radio value="instructormembership">
                  <template v-slot:label class="d-flex">
                    <v-row>
                      <v-col>
                        <div class="mt-2 black--text">Instructor</div>
                      </v-col>
                      <v-col>
                        <div class="mt-2 black--text">$ 300.00</div>
                      </v-col>
                    </v-row>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row> -->
            <v-card flat outlined class="px-4 mt-4 py-6">
              <div>
                        <b class="mb-3 d-flex align-center">Name on Card *</b>
                        <v-text-field
                          outlined
                          dense
                          label="Card Holder Name"
                          single-line
                          v-model="form.Payment.CardHolderName"
                          :error-messages="
                            getErrorMessagePayment(
                              'CardHolderName',
                              'CardHolderName'
                            )
                          "
                        ></v-text-field>
                        <b class="mb-3 d-flex align-center">Card Number *</b>
                        <v-text-field
                          outlined
                          dense
                          label="Card Number"
                          single-line
                          v-model="form.Payment.CardNumber"
                          maxlength="16"
                          :error-messages="
                            getErrorMessagePayment('CardNumber', 'CardNumber')
                          "
                        ></v-text-field>
                        <div class="d-flex gap-3">
                        <div class="w-100">
                        <b class="mb-3 d-flex align-center">Expiration Date *</b>
                        <v-text-field
                          outlined
                          dense
                          label="MM/YY"
                          single-line
                          maxlength="5"
                          @input="formatExpiryDate"
                          v-model="form.Payment.CardExp"
                          :error-messages="
                            getErrorMessageExpiryDate(form.Payment.CardExp)
                          "
                        ></v-text-field>
                      </div>
                        <div class="w-100">
                        <b class="mb-3 d-flex align-center">
                          CVV *
                        </b>
                        <v-text-field
                          outlined
                          dense
                          label="CVV"
                          single-line
                          :maxlength="form.Payment.CardNumber?.length === 15 ? 4 : 3"
                          v-model="form.Payment.CardCVV"
                          :error-messages="
                            getErrorMessagePayment('CardCVV', 'CardCVV')
                          "
                        ></v-text-field>
                      </div>
                    </div>
                    <b class="">
                      Discount Code
                    </b>
                    <div>
                    <input type="text" class="searchfield mt-2 mr-3" v-model="ValidateCouponCode" />
                      <v-btn
                        color="primary"
                        text
                        @click="ValidateCoupon"
                      >
                        <span >Validate</span>
                        <!-- <v-progress-circular
                          indeterminate
                          size="20"
                          class="px-5"
                          color="black"
                        ></v-progress-circular> -->
                      </v-btn>
                    </div>
            <div class="d-flex align-center gap-4 mt-5">
              <div><b>Membership Price:</b></div>
              <div>${{ membershipPrice?.toFixed(2) }}</div>
            </div>
            <div class="d-flex align-center gap-4 mt-1">
              <div><b>Prorated Adjustment:</b></div>
              <div>${{ this.form.proratedAdjustment?.toFixed(2) }}</div>
            </div>
            <div class="d-flex align-center gap-4 mt-1">
              <div><b>Discount:</b></div>
              <div>${{ couponDiscount?.toFixed(2) }}</div>
            </div>
            <div class="d-flex align-center gap-4 mt-1">
              <div><b>Total Price:</b></div>
              <div>${{ totalAmountPaid?.toFixed(2) }}</div>
            </div>
              </div>
            </v-card>
          </div>
          <div class="d-flex justify-end gap-3 mt-8">
            <div>
              <v-btn
              color
              outlined
                class="px-8"
                v-show="this.stepTwo == true"
                @click="GoBack()"
                >cancel</v-btn
              >
            </div>
            <div>
              <v-btn
                color="primary"
                class="px-9"
                v-if="this.PaymentOption === 'offline' || this.stepTwo == true"
                :disabled="btnloader"
                @click="Submit()"
                ><span v-if="btnloader != true">Submit</span>
                <v-progress-circular
                  indeterminate
                  size="20"
                  v-else
                  class="px-5"
                  color="white"
                  v-show="btnloader"
                ></v-progress-circular
              ></v-btn>
              <v-btn
                color="primary"
                class="px-9"
                v-if="this.PaymentOption === 'online'"
                v-show="this.stepTwo == false"
                @click="GoToStepTwo()"
                >Next
              </v-btn>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="OfflineSuccessfullDialog" max-width="400" persistent>
      <v-card class="pa-5 pb-8" v-if="OfflineSuccessfullDialog">
        <div class="d-flex justify-end">
          <v-icon @click="closeOfflineSuccessDialog()">mdi-close</v-icon>
        </div>
        <div v-if="this.PaymentOption === 'offline'">
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your offline payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
        <div v-else>
          <div
            class="d-flex justify-center"
            style="font-size: 2rem; color: rgb(63, 72, 204); font-weight: bold"
          >
            Success
          </div>
          <div class="d-flex justify-center mt-5" style="font-size: 1.3rem">
            Your payment has been <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            processed. A record of this <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction and an invoice will <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            be recorded in this User's <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            account. An email of the <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            transaction details will be sent <br />
          </div>
          <div class="d-flex justify-center" style="font-size: 1.3rem">
            to the User.
          </div>
        </div>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  required,
  numeric,
  minLength,
} from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
const alphaWithSpacesAndSpecialChars = (value) => {
  if (!value) return true;
  // return /^[A-Za-z\s]+$/.test(value);    //to allow spaces
  // return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+$/.test(value); //to allow spaces and special characters

  return /^[A-Za-z\s!@#$%^&*()_+\-=[\]{};'’:"\\|,.<>/?áàãâäåāăąçćĉċčðďèéêëēĕėęěĝğġģĥħìíîïĩīĭįıĵķĺļľłńņňŋòóôõöøōŏőœñŕŗřśŝşšţťŧùúûüũūŭůűųŵýÿŷźżžÁÀÃÂÄÅĀĂĄÇĆĈĊČÐĎÈÉÊËĒĔĖĘĚĜĞĠĢĤĦÌÍÎÏĨĪĬĮİĴĶĹĻĽŁŃŅŇŊÒÓÔÕÖØŌŎŐŒŔŖŘŚŜŞŠŢŤŦÙÚÛÜŨŪŬŮŰŲŴÝŸŶŹŻŽ\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF]+$/.test(value);
  // to allow spaces, special char, latin char. Japanese characters (Kanji, Hiragana and Katakana scripts)
};
const allowDigitsAndSteric = (value) => {
  if (!value) return true;
  return /^[0-9*]+$/.test(value); // to allow digits and *
};
export default {
  props: ["PaymentProcess"],
  name: "UserPaymentComponent",
  mixins: [validationMixin],
  data() {
    return {
      btnloader: false,
      OfflineSuccessfullDialog: false,
      items: [
        "Renew current - Standard - $150",
        "Change to - Life Science - $0",
        "Change to - Practitioner - $300 Prorated",
        "New -Life Sceince - $75",
        "New - Standard - $150",
      ],
      membershipData: [
        { text: "Starter - $0", id: 1, amount: 0 },
        { text: "Access - $40", id: 2, amount: 40 },
        { text: "Standard - $150", id: 3, amount: 150 },
        { text: "Practitioner  - $300", id: 4, amount: 300 },
        { text: "Instructor  - $300", id: 5, amount: 300 },
      ],
      memberShipName: "",
      username: "Miranda Jemieson ",
      exam: "CBP, CBP-A",
      Credentials: "CBP, BAT",
      statusdate: "October 14, 2023",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      PaymentFor: [],
      PaymentOption: "offline",
      PaymentInformationFee: [],
      stepOne: true,
      stepTwo: false,
      form: {
        UserId: 0,
        UserMembershipId: 0,
        MembershipId: null,
        // BillingDetails: {
        //   Id: 0,
        //   FirstName: "",
        //   LastName: "",
        //   StreetAddress1: "",
        //   StreetAddress2: "",
        //   City: "",
        //   Province: "",
        //   ZipCode: "",
        //   Country: "",
        //   PhoneNumber: "",
        //   UserId: 0,
        // },
        Payment: {
          PaymentCardId: 0,
          PaymentType: 1,
          CardHolderName: "",
          CardNumber: "",
          CardExp: "",
          CardCVV: "",
        },
        proratedAdjustment: 0,
        Coupon:0,
        CheckoutType: 1,
        AmountPaid: 0,
      },
      offlineMemberForm: {
        UserId: 0,
        UserMembershipId: 0,
        MembershipId: 0,
        AmountPaid: 0,
        proratedAdjustment: 0,
      },
      membershipId: null,
      membershipPrice: 0,
      ValidateCouponCode: null,
      coupon: null,
    };
  },
  validations: {
    form: {
      MembershipId: {
        required,
      },
      Payment: {
        CardHolderName: { required, alpha: alphaWithSpacesAndSpecialChars },
        CardNumber: {
          required,
          numeric,
          minLength: minLength(15),
        },
        CardExp: {
          required,
          expiryDate(value) {
            if (!value) {
              return "Expiry date is required.";
            }

            const [month, year] = value.split("/");
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;

            if (
              parseInt(month) >= 1 &&
              parseInt(month) <= 12 &&
              parseInt(year) >= currentYear &&
              ((parseInt(year) === currentYear &&
                parseInt(month) >= currentMonth) ||
                parseInt(year) > currentYear)
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        CardCVV: { required, allowDigitsAndSteric: allowDigitsAndSteric, minLength: minLength(3), },
      },
    },
  },
  // validations: {
  //   form: {
  //     MembershipId: {
  //       required,
  //     },
  //   },
  // },
  mounted() {
    this.form.UserMembershipId = this.getMembershipByUserId?.Id;
    this.form.UserId = this.GetPreviewUser?.Id;
    this.offlineMemberForm.UserMembershipId = this.getMembershipByUserId?.Id;
    this.offlineMemberForm.UserId = this.GetPreviewUser?.Id;
    switch (this.getMembershipByUserId?.Name) {
      case "Starter":
        this.membershipId = 1;
        break;
      case "Access":
        this.membershipId = 2;
        break;
      case "Standard":
        this.membershipId = 3;
        break;
      case "Practitioner":
        this.membershipId = 4;
        break;
    }
  },
  computed: {
    ...mapGetters([
      "getMembershipByUserId",
      "GetPreviewUser",
      "getBillingDetailsInfoByUserId",
    ]),
    
    combinedCredentials() {
      const examMapping = {
        1: "CBP",
        2: "CBP-A",
        3: "AdvCBP",
        4: "PaRama CBP"
      };

      let exams = (this.GetPreviewUser?.ExamsCredentials || []).map(exam => examMapping[exam] || exam);
      let courses = (this.GetPreviewUser?.CourseTaughtCredentials || []).map(c => c.CredentialEarned);

      return [...exams, ...courses].join(", ") || "";
    },
    couponDiscount() {
      if (this.coupon === null) {
        return 0;
      }
      if (this.coupon?.DiscountType === 1) {
        return this.membershipPrice * (parseFloat(this.coupon?.DiscountValue) / 100);
      }
      return this.coupon?.DiscountValue;
    },
    getCurrentDateFormatted() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      const currentDate = new Date();
      const month = months[currentDate.getMonth()];
      const date = currentDate.getDate();
      const year = currentDate.getFullYear() + 1;
      return `${month} ${date}, ${year}`;
    },
    totalAmountPaid(){
      return this.membershipPrice - this.couponDiscount - (this.offlineMemberForm?.proratedAdjustment || this.form?.proratedAdjustment)
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", { 
        year: "numeric", 
        month: "long", 
        day: "numeric" 
      });
    },
    ValidateCoupon() {
      var obj = {
        Code: this.ValidateCouponCode,
        Type: "Membership",
      };
      this.$store.dispatch("ValidateCoupon", obj).then((res) => {
        if (res.Status) {
          this.form.Coupon = res.Data.Code;
          this.coupon = res.Data;
          this.$swal.fire({
            position: "top-end",
            icon: res.Message == "Valid Coupon" ? "success" : "error",
            title: res.Message,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
        }
      });
      // }
    },
    closeOfflineSuccessDialog() {
      this.OfflineSuccessfullDialog = false;
      this.close();
    },
    formatExpiryDate() {
      if (
        this.form.Payment.CardExp.length === 2 &&
        !this.form.Payment.CardExp.includes("/")
      ) {
        this.form.Payment.CardExp += "/";
      }
    },
    getErrorMessagePayment(fieldName) {
      const errorMessages = {
        CardHolderName: {
          required: "Cardholder Name is required",
          alpha: "Only alphabetical characters are allowed.",
        },
        CardNumber: {
          required: "Card number is required",
          minLength: "Minimum of 15 digits is required",
          numeric: "Alphabetic characters are not allowed",
        },
        CardCVV: {
          required: "Card CVV is required",
          allowDigitsAndSteric: "Alphabetic characters are not allowed",
          // minLength: "Minimum of 3 digits are required",
          invalidLength: `Minimum of ${
            this.form.Payment.CardNumber?.length === 15 ? 4 : 3
          } digits are required`,
        },
      };
      const errorField = this.$v.form.Payment[fieldName];
      if (!errorField.$dirty) return null;
      if (fieldName === "CardCVV") {
        const cardLength = this.form.Payment.CardNumber?.length;
        const expectedCvvLength = cardLength === 15 ? 4 : 3;

        if (!this.form.Payment.CardCVV) return errorMessages.CardCVV.required;
        if (!/^\d*$/.test(this.form.Payment.CardCVV)) {
          return errorMessages.CardCVV.allowDigitsAndSteric;
        }
        if (this.form.Payment.CardCVV.length !== expectedCvvLength) {
          return errorMessages.CardCVV.invalidLength;
        }
      }
      const errors = [];
      Object.keys(errorField.$params).forEach((param) => {
        if (!errorField[param]) {
          errors.push(errorMessages[fieldName][param]);
        }
      });
      return errors.length ? errors[0] : null;
    },
    getErrorMessageExpiryDate(field) {
      if (this.$v.form.Payment.CardExp.$error == false) {
        return null;
      }
      if (!field) {
        return "Expiration date is required";
      }
      return "Invalid expiration date.";
    },
    close() {
      this.$emit("close");
    },
    GetMembershipByUserId() {
      const obj = {
        id: this.GetPreviewUser.Id,
      };
      this.$store.dispatch("GetMembershipByUserId", obj);
    },
    calculateRemainingMonths(givenDate) {
      const targetDate = new Date(givenDate);
      const currentDate = new Date();

      const targetYear = targetDate.getFullYear();
      const targetMonth = targetDate.getMonth();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const yearDifference = targetYear - currentYear;
      const monthDifference = targetMonth - currentMonth;
      const remainingMonths = yearDifference * 12 + monthDifference;

      return remainingMonths;
    },
    async Submit() {
      // Trigger validation for MembershipId
      this.$v.form.MembershipId.$touch();

      if (this.$v.form.MembershipId.$invalid) {
        console.log("Membership validation failed");
        return;
      }

      // If PaymentOption is "offline", handle offline logic
      if (this.PaymentOption === "offline") {
        try {
          const selectedMembership = this.membershipData.find(
            (member) => member.id === this.form.MembershipId
          );

          if (selectedMembership) {
            this.offlineMemberForm.AmountPaid = selectedMembership.amount;
            this.offlineMemberForm.MembershipId = selectedMembership.id;
          }

          // Calculate prorated adjustment for upgrade
          if (this.form.MembershipId > this.membershipId) {
            const current = this.membershipData.find(
              (member) => member.id === this.form.MembershipId
            );
            const previous = this.membershipData.find(
              (member) => member.id === this.membershipId
            );

            if (current && previous) {
              const amountDifference = current.amount - previous.amount;
              const monthlyDifference = (
                Math.floor((amountDifference / 12) * 100) / 100
              ).toFixed(2);

              const remainingMonths = Number(
                this.calculateRemainingMonths(this.getMembershipByUserId?.EndDateTime)
              );

              const proratedAmount = remainingMonths * Number(monthlyDifference);

              if (remainingMonths > 0) {
                this.offlineMemberForm.proratedAdjustment = proratedAmount;
              }
            }
          }

          this.offlineMemberForm.AmountPaid =
            (this.offlineMemberForm.MembershipId === 2
              ? 40
              : this.offlineMemberForm.MembershipId === 3
              ? 150
              : this.offlineMemberForm.MembershipId === 4
              ? 300
              : this.offlineMemberForm.MembershipId === 5
              ? 300
              : 0) -
            this.couponDiscount -
            (this.offlineMemberForm?.proratedAdjustment || 0);

          this.btnloader = true;

          await this.$store.dispatch(
            "UserMemberShipOfflinePayment",
            this.offlineMemberForm
          ).then((res) => {
            if (res?.Status) {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "success",
                title: "Offline payment successful",
                showConfirmButton: false,
                timer: 1500,
              });
  
              this.GetMembershipByUserId();
              this.OfflineSuccessfullDialog = true;
            } else {
              this.$swal.fire({
                toast: true,
                position: "top-end",
                icon: "error",
                title: res?.Message || "Offline payment failed",
                showConfirmButton: false,
                timer: 3000,
              });
            }

          });

        } catch (error) {
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: error?.message || "Something went wrong",
            showConfirmButton: false,
            timer: 3000,
          });
        } finally {
          this.btnloader = false;
        }

        return;
      }

      // If PaymentOption is "online", validate Payment fields
      this.$v.form.Payment.$touch();

      if (this.$v.form.Payment.$invalid) {
        return;
      }

      // Dynamic CVV validation based on CardNumber length
      const cardLength = this.form.Payment.CardNumber?.length;
      const expectedCvvLength = cardLength === 15 ? 4 : 3;

      if (
        !this.form.Payment.CardCVV ||
        this.form.Payment.CardCVV.length !== expectedCvvLength
      ) {
        return;
      }

      // Calculate prorated adjustment for upgrades
      if (this.form.MembershipId > this.membershipId) {
        const current = this.membershipData.find(
          (member) => member.id === this.form.MembershipId
        );
        const previous = this.membershipData.find(
          (member) => member.id === this.membershipId
        );

        if (current && previous) {
          const amountDifference = current.amount - previous.amount;
          const monthlyDifference = (
            Math.floor((amountDifference / 12) * 100) / 100
          ).toFixed(2);
          const remainingMonths = Number(
            this.calculateRemainingMonths(this.getMembershipByUserId?.EndDateTime)
          );
          const proratedAmount = remainingMonths * Number(monthlyDifference);

          if (remainingMonths > 0) {
            // this.form.proratedAdjustment = this.membershipPrice - proratedAmount;
            this.form.proratedAdjustment = proratedAmount;
          }
        }
      }

      // Prepare data for online payment
      this.form.AmountPaid = this.totalAmountPaid;

      try {
        this.btnloader = true;

        const res = await this.$store.dispatch(
          "UserMemberShipPayment",
          this.form
        );

        if (res?.Status) {
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Payment submitted successfully",
            showConfirmButton: false,
            timer: 1500,
          });

          this.close();
          this.GetMembershipByUserId();
        } else {
          this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: res?.Message || "Payment failed",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (error) {
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: error?.message || "Something went wrong",
          showConfirmButton: false,
          timer: 3000,
        });
      } finally {
        this.btnloader = false;
      }
    },

    GoToStepTwo() {
      if (this.PaymentOption === "online") {
        const selectedMembership = this.membershipData.find(
          (member) => member.id === this.form.MembershipId
        );
        if (selectedMembership) {
          this.membershipPrice = selectedMembership.amount;
          this.memberShipName = selectedMembership?.text?.split(" ")[0];
        }
      }

      this.$v.form.MembershipId.$touch();
      if (this.$v.form.MembershipId.$invalid) {
        return;
      }

      if (this.form.MembershipId > this.membershipId) {
        const current = this.membershipData.find(
          (member) => member.id === this.form.MembershipId
        );
        const previous = this.membershipData.find(
          (member) => member.id === this.membershipId
        );

        if (current && previous) {
          const amountDifference = current.amount - previous.amount;
          const monthlyDifference = (Math.floor((amountDifference / 12) * 100) / 100)?.toFixed(2);
          const remainingMonths = Number(this.calculateRemainingMonths(this.getMembershipByUserId?.EndDateTime));
          const proratedAmount = remainingMonths * Number(monthlyDifference);
          if(remainingMonths > 0){
            // this.form.proratedAdjustment = this.membershipPrice - proratedAmount
            this.form.proratedAdjustment = proratedAmount
          }
          this.form.AmountPaid = this.membershipPrice;
        }
      }

      this.stepOne = false;
      this.stepTwo = true;
    },
    GoBack() {
      this.stepTwo = false;
      this.stepOne = true;
      this.$v.$reset();
      this.form.proratedAdjustment = 0;
    },
  },
};
</script>

<style scoped>
.searchfield {
  background: #f7f8fc;
  padding: 0.6rem;
  width: 60%;
  border-radius: 7px;
  outline: none;
}
.h1 {
  font-size: 26px;
  font-weight: 700;
}
.h2 {
  font-size: 22px;
  font-weight: 700;
}
.font-18 {
  font-size: 18px;
}
table,
td,
th {
  border: 1px solid;
}
th {
  background-color: #cccccc;
}
.divider {
  border-color: #e6e6e6;
}
</style>
